import { AppPermissions } from "@my-aon/auth";

import { Navigation } from '@my-aon/layout';

export const healthRequestsNavigation: Navigation[] = [
    {
        title: 'HEALTH.REQUESTS.MOVEMENT.LABEL_REQUESTS',
        id: 'movement-requests',
        path: 'movement',
        requiredPermissionsAny: [AppPermissions.HW_REQUESTS_READ_REQUESTS],
    },
    {
        title: 'HEALTH.REQUESTS.COMPLETE_DATA.LABEL_REQUESTS',
        id: 'complete-data-requests',
        path: 'complete-data',
        requiredPermissionsAny: [
            AppPermissions.HW_REQUESTS_COMPLETEDATA_READ_REQUESTS,
        ],
    },
];

export const healthNavigation: Navigation[] = [
    {
        title: 'HEALTH.ENROLLMENTS.PAGE_TITLE_ENROLLMENTS',
        id: 'enrollments',
        path: 'health/enrollments',
        requiredPermissionsAny: [
            AppPermissions.HW_ENROLLMENTS_READ_ENROLLMENTS,
        ],
    },

    {
        title: 'HEALTH.REQUESTS.PAGE_TITLE_REQUESTS',
        id: 'requests',
        path: 'health/requests',
        requiredPermissionsAny: [
            AppPermissions.HW_REQUESTS_READ_REQUESTS,
            AppPermissions.HW_REQUESTS_COMPLETEDATA_READ_REQUESTS,
        ],
        items: healthRequestsNavigation,
    },
]
